import React, { Fragment } from 'react';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  TableCell,
  TableRow,
  Tooltip,
  colors,
  Avatar,
  IconButton,
  Icon,
  Grid,
  Link,
  Typography
} from '@material-ui/core';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import BuildIcon from '@material-ui/icons/Build';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';

const useStyles = makeStyles((theme) => ({
  avatar1: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.orange[200]
  },
  selectedRow: {
    backgroundColor: colors.orange[100]
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  },
  inday: {
    backgroundColor: colors.green[600],
    color: colors.common.white
  },
  cpclate: {
    backgroundColor: colors.red[600],
    color: colors.common.white
  },
  cpalate: {
    backgroundColor: colors.red[600],
    color: colors.common.white
  }
}));

const formatDecimal = (value) => {
  return numeral(value).format('0.00').replace('.', ',');
}

const formatNumber = (value, mask) => {
  return numeral(value).format(mask);
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY')
  } else {
    return ""
  }
}

const truncateValue = (value, size) => {
  if (value.length > size) {
    return value.substring(size - 3, 0) + '...';
  } else {
    return value;
  }
}


const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Record = ({ icon, item, vision, resultMode, openEdition, openDeletion, openTreatment, appointments, values }) => {

  const classes = useStyles();

  const getName = (value) => {
    return appointments.typesTechnician.map((element, index) => {
      if (element.id == value.tecnico.PRESTADORA) {
        return element.nome;
      }
    });
  }

  const getFieldValue = (column) => {
    try {
      var value = eval(column.field);
      return ((value) ? value : "");
    } catch (error) {
      return "";
    }
  }

  const getStyleActionsAjustment = (resultMode) => {
    var distance = (resultMode.update + resultMode.delete + resultMode.config) * 160;
    return { maxWidth: distance, minWidth: distance };
  }

  const isRowSelected = (item, ocorrencia) => {
    if (item && ocorrencia) {
      if (item.dataAgenda) {
        if (item.hora) {
          return item.hora == ocorrencia.hora
        } else {
          return item.dataAgenda == ocorrencia.dataPrevistaAtendimento
        }
      } else {
        return item.dataAgenda == ocorrencia.dataPrevistaAtendimento
      }
    } else {
      return false
    }


    /*
    if (item && item.hora && item.dataAgenda && ocorrencia && ocorrencia.hora && ocorrencia.dataPrevistaAtendimento) {
      return (item.hora == ocorrencia.hora) && (item.dataAgenda == ocorrencia.dataPrevistaAtendimento)
    } else return false
    */
  }

  return (
    <Fragment>

      <TableRow hover key={item.id} className={isRowSelected(item, values.ocorrencia) ? classes.selectedRow : ""} >

        {resultMode.columns.map((col, index) => (
          (index == 0) ? (

            <TableCell>
              <Box
                noWrap={(col.wrap)}
                alignItems="center"
                display="flex"
                component={Link}
                onClick={() => { (resultMode.update == LEVEL_ACCESS_ENABLED) ? openEdition(item) : {} }}
              >
                <Avatar
                  className={isRowSelected(item, values.ocorrencia) ? classes.avatar1 : classes.avatar}
                >
                  {(isRowSelected(item, values.ocorrencia)) ?
                    (<Icon component={EventAvailableIcon} style={{ color: colors.orange[800] }} ></Icon>)
                    :
                    (<Icon component={icon} style={{ color: colors.cyan[500] }} ></Icon>)
                  }

                </Avatar>

                {isRowSelected(item, values.ocorrencia) ?
                  <Typography variant="body" noWrap={(col.wrap)} >
                    {getFieldValue(col)}
                  </Typography>
                  :
                  <Typography variant="body" noWrap={(col.wrap)} style={{ textDecoration: "line-through" }}>
                    {getFieldValue(col)}
                  </Typography>
                }

              </Box>
            </TableCell>

          ) : (
            <TableCell>
              {isRowSelected(item, values.ocorrencia) ?
                <Typography variant="body" noWrap={(col.wrap)} >
                  {getFieldValue(col)}
                </Typography>
                :
                <Typography variant="body" noWrap={(col.wrap)} style={{ textDecoration: "line-through" }}>
                  {getFieldValue(col)}
                </Typography>
              }
            </TableCell>)
        ))}

        <TableCell align="right" >
          <Grid container style={getStyleActionsAjustment(resultMode)} >
            {(resultMode.config != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title="Tratar">
                  <IconButton
                    color="secondary"
                    disabled={resultMode.config == LEVEL_ACCESS_DISABLED}
                    children={<BuildIcon />}
                    size="medium"
                    onClick={() => { openTreatment(item) }}></IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

            {(resultMode.update != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title="visualizar">
                  <IconButton
                    color="secondary"
                    disabled={resultMode.update == LEVEL_ACCESS_DISABLED}
                    children={<EditRoundedIcon />}
                    size="medium"
                    onClick={() => { openEdition(item) }}>
                  </IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

            {(resultMode.delete != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title={"Excluir"}>
                  <IconButton
                    color="secondary"
                    disabled={resultMode.delete == LEVEL_ACCESS_DISABLED}
                    children={<DeleteRoundedIcon />}
                    size="medium"
                    onClick={() => { openDeletion(item) }}></IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

          </Grid>
        </TableCell>

      </TableRow>

    </Fragment >
  );
}

export default Record;